import type { ReactNode } from "react";
import type { FirmLogoFillCandidate } from "../../../api/firmLogoFill.service.js";
import { buildFilesUrl } from "../../../api/filesUrl.js";
import { LogoThumbnail } from "./LogoThumbnail.js";
import styles from "./FirmLogoCopy.module.css";

export type CandidateSelection = "none" | "selected" | "unselected";

type CandidateCardProps = {
  candidate: FirmLogoFillCandidate;
  position: number;
  firmName: string;
  isCurrent: boolean;
  selection: CandidateSelection;
  children?: ReactNode;
};

const SELECTION_CLASSES: Record<CandidateSelection, string> = {
  none: "",
  selected: styles.isSelected,
  unselected: styles.isUnselected,
};

function usedOnText(locations: string[]): string {
  return `Used on: ${locations.length > 0 ? locations.join(", ") : "None"}`;
}

export function CandidateCard({
  candidate,
  position,
  firmName,
  isCurrent,
  selection,
  children,
}: CandidateCardProps) {
  const classNames = [styles.candidate, SELECTION_CLASSES[selection]].filter(Boolean);

  return (
    <li className={classNames.join(" ")}>
      <LogoThumbnail
        url={buildFilesUrl({ hash: candidate.logoHash, filename: candidate.logoFilename })}
        alt={`${firmName} logo ${position}`}
      />
      <p className={styles.candidateLocations}>{usedOnText(candidate.locations)}</p>
      {isCurrent ? <span className={styles.candidateBadge}>Current logo</span> : null}
      {children}
    </li>
  );
}
